﻿import { observer } from 'mobx-react-lite';
import React from 'react';
import { useStores } from '../../../common/hooks';
import { PageTitle } from '../../shared-components';
import { FlexBox } from '../../shared-components/flex-box';
import { AwardedNominationTile } from './AwardedNominationTile';
import './AwardedNominations.scss';

const AwardedNominationsImpl: React.FC = () => {
  const {
    nominationDashboardPageUiStore,
  } = useStores();

  return (
    <div
      className='awarded-nominations'
    >
      <PageTitle
        title='Awarded Nominations'
        textHeaderTag='h2'
        titleSize={700}
      />
      <FlexBox
        wrap
        className='awarded-nominations__tiles'
      >
        {
          nominationDashboardPageUiStore.awardedNominations.map((awardedNomination, index) =>
            <AwardedNominationTile
              key={index}
              awardedNomination={awardedNomination}
            />)
        }
      </FlexBox>
    </div>
  );
}

export const AwardedNominations = observer(AwardedNominationsImpl);
